import Tween from 'gsap';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import {scrollTo} from "./tools/Scroll";

const moduleContact = () => import(
	/* webpackChunkName: "contact-component" */ './contact'
	)

gsap.registerPlugin(ScrollToPlugin);

/**
 * Component
 * @type {function(): {}}
 * @name frontComponent
 */
export const frontComponent = () => {

	const eventsActions = () => {

		window.dispatchEvent(new Event('scroll'));
	};

	const scrollActions = () => {

		let lastscroll = 0;
		let preHeadSavedScroll = 0;

		const hasPreHead = document.querySelector('#pre-head')
		const header = document.querySelector('#header')

		window.addEventListener('scroll', () => {

			let direction;

			if ( (window.scrollY - lastscroll) >= 25 || (window.scrollY - lastscroll) <= -25 ) {

				direction  = ( window.scrollY > lastscroll ) ? 'down':'up';
				lastscroll = window.scrollY;
			}


			if (hasPreHead && window.scrollY < hasPreHead.clientHeight) {
				const value = `${Math.max((window.scrollY * -1), (hasPreHead.clientHeight * -1))}px`
				header.style.marginTop = value
				preHeadSavedScroll = value
				header.classList.add('is-prehead-constrain')
			} else {
				header.classList.remove('is-prehead-constrain')
			}

			if ( window.scrollY >= (hasPreHead ? hasPreHead.clientHeight+header.clientHeight : 30) ) {
				document.body.classList.add('scrolled');
				if (direction === 'up') {
					document.body.classList.add('scrolled-up');
					document.body.classList.remove('scrolled-down');
					header.style.marginTop = ''
				} else if (direction === 'down') {
					document.body.classList.remove('scrolled-up');
					document.body.classList.add('scrolled-down');
					header.style.marginTop = preHeadSavedScroll
				}
			} else if (hasPreHead) {
				if (window.scrollY < (hasPreHead ? hasPreHead.clientHeight : 30)) {
					document.body.classList.remove('scrolled');
				}
			} else {
				document.body.classList.remove('scrolled');
			}

			const currentEndScroll = window.scrollY + window.innerHeight;
			const scrollLimit = Math.max(
				document.body.scrollHeight,
				document.body.offsetHeight,
				document.documentElement.clientHeight,
				document.documentElement.scrollHeight,
				document.documentElement.offsetHeight);

			if (currentEndScroll >= scrollLimit) {
				document.body.classList.add('end-scroll');
			} else {
				document.body.classList.remove('end-scroll');
			}
		});
	};

	const menuActions = () => {

		let btn = document.getElementById('toggle-menu-mobile');
		let btnclose = document.getElementById('close-menu');

		if( !btn || !btnclose ) return;

		const wrapMenu = document.querySelector('#menu-app')
		const wrapMenuLeft = wrapMenu.querySelector('.left-col')
		const wrapMenuLeftItems = wrapMenu.querySelectorAll('.left-col > *')
		const wrapLeftMenuItems = wrapMenu.querySelectorAll('.left-col #menu-app-menu .menu-item')
		const wrapMenuRight = wrapMenu.querySelector('.right-col')
		const wrapMenuRightItems = wrapMenu.querySelectorAll('.right-col .head-menu-col > *')
		const wrapMenuServicesItems = wrapMenu.querySelectorAll('#menu-services > *')
		const textBack = wrapMenu.querySelector('.textback-menu-col')
		const tl = Tween.timeline({paused: true});

		tl.timeScale( 1.25 );
		tl.fromTo(wrapMenu,{width:0},{width: '100%', ease: "power4.inOut", duration: 1.25}, 0);
		tl.addLabel("menuLeft", '<');
		tl.addLabel("menuRight", '<');
		tl.fromTo(wrapMenuLeft,{x:'-100%'},{duration: 1.25, x: 0, ease: "power4.out"}, 'menuLeft');
		tl.fromTo(wrapMenuRight,{x:'-100%'},{duration: 1.25, x: 0, ease: "power4.inOut"}, 'menuRight');

		tl.addLabel("menuLeftItems", 'menuLeft+=.5');
		tl.addLabel("menuRightItems", 'menuRight+=.75');

		wrapMenuLeftItems.forEach(function (item, index) {
			tl.fromTo(item,{x: -30, opacity:0},{x: 0, opacity: 1, ease: "power4.inOut", duration: 2}, 'menuLeftItems+='+ (.15 * (index)) );
		})

		wrapMenuRightItems.forEach(function (item, index) {
			tl.fromTo(item,{x: -30, opacity:0},{x: 0, opacity: 1, ease: "power4.inOut", duration: 3}, 'menuRightItems+='+ (.35 * (index)) );
		})

		tl.fromTo(wrapLeftMenuItems,{x: -30, opacity:0},{x: 0, opacity: 1, ease: "Power4.easeOut", duration: 1.5, stagger: 0.115}, 'menuRightItems' );

		tl.addLabel("endRightItems", '<.35');

		wrapMenuServicesItems.forEach(function (item, index) {
			tl.fromTo(item,{y: -20, opacity:0},{y: 0, opacity: 1, ease: "power4.inOut", duration: 1.5}, 'endRightItems+='+ (.15 * (index)) );
		})

		const mouse = {x: 0, y: 0}
		let frame = null

		wrapMenu.addEventListener('mousemove', (event) => {
			mouse.x = event.pageX
			mouse.y = event.pageY
			cancelAnimationFrame(frame)
			frame = requestAnimationFrame(updateBackMenu)
		})

		function updateBackMenu() {
			const x = (mouse.x - (wrapMenu.clientWidth/2)) / wrapMenu.clientWidth * 100
			const y = (mouse.y - (wrapMenu.clientHeight/2)) / wrapMenu.clientHeight * 100
			Tween.to(textBack,{x: x, y: y, ease: "power4.out", duration: 10})
		}


		const openMenu = () => {

			btn.classList.add('open')
			wrapMenu.classList.add('open')
			tl.timeScale(1.5)
			tl.pause()
			tl.resume()
			tl.play()
		}

		const closeMenu = () => {

			btn.classList.remove('open')
			wrapMenu.classList.remove('open')
			tl.timeScale(4)
			tl.pause()
			tl.resume()
			tl.reverse()
		}

		btn.addEventListener('click', () => {
			openMenu()
		})

		btnclose.addEventListener('click', () => {
			closeMenu()
		})

		return {
			closeMenu: () => {
				closeMenu()
			},
			openMenu: () => {
				openMenu()
			}
		}
	};

	const uiActions = () => {

		const updateLayout = () => {
			const LAYOUTABLE_ITEMS = document.querySelectorAll('[data-layout-item]')
			const LAYOUT_ITEMS = document.querySelectorAll('[data-layout]')
			if (LAYOUT_ITEMS.length && LAYOUTABLE_ITEMS.length) {
				// pour chaque element "layout-influençable"
				for (const layoutAble of LAYOUTABLE_ITEMS) {
					const layoutAbleRect = layoutAble.getBoundingClientRect()
					layoutAble.dataset.layoutItem = ''
					// pour chaque element "layout-changer"
					for (const layoutChanger of LAYOUT_ITEMS) {
						const layoutChangerRect = layoutChanger.getBoundingClientRect()
						const overlap = (
							!(layoutAbleRect.left >= layoutChangerRect.right || layoutAbleRect.right <= layoutChangerRect.left)
							&&
							!(layoutAbleRect.top >= layoutChangerRect.bottom || layoutAbleRect.bottom <= layoutChangerRect.top)
						)
						if (overlap) {
							layoutAble.dataset.layoutItem = layoutChanger.dataset.layout
							break
						} else {
							layoutAble.dataset.layoutItem = ''
						}
					}
				}
			} else {
				for (const layoutAble of LAYOUTABLE_ITEMS) {
					layoutAble.dataset.layoutItem = ''
				}
			}
		}

		const layoutAction = () => {
			window.addEventListener('scroll', () => {
				updateLayout()
				// sidebarLayout()
			})
			window.addEventListener('resize', () => {
				// sidebarLayout()
			})
		}

		layoutAction()

		return {
			scrollTo: (target, link, context) => {
				scrollTo(target, link, context)
			},
			updateLayout: () => {
				updateLayout()
			}
		}
	}

	const loader = (flag) => {
		const loader = document.querySelector('#root-loader')
		const loading = (flag) => {
			if (flag) {
				loader.classList.add('loading')
			} else {
				loader.classList.remove('loading')
			}
		}
		return {
			loader: loading(flag)
		}
	}

	/**
	 * Execution permanente
	 */

	scrollActions()
	eventsActions()

	const exposed = {
		uiActions: uiActions(),
		menuActions: menuActions(),
		contactActions: null,
		loader: (flag) => {
			loader(flag)
		}
	}

	moduleContact().then((module) => {
		exposed.contactActions = new module.moduleContact()
	})

	return exposed
};

self.components = self.components || {};
self.components.front = frontComponent();

// if (!self.components.front.contactActions.initiated) {
//     console.log('init front comp')
//     self.components.front.contactActions.init()
// }
